import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import ProjectService, { IProjectBaseOption } from '../../service/project/ProjectService';

interface ProjectManagerOption {
    id: number;
    name: string;
}

interface ProjectManagerSelectProps {
    className?: string;
    value?: number;
    onChange?: (value: number | null) => void;
    placeholder?: string;
    allowClear?: boolean;
    disabled?: boolean;
}

let cachedProjectManagerOptions: ProjectManagerOption[] | null = null;
let pendingFetch: Promise<ProjectManagerOption[]> | null = null;

const fetchProjectManagerOptions = async (): Promise<ProjectManagerOption[]> => {
    if (cachedProjectManagerOptions) {
        return cachedProjectManagerOptions;
    }
    if (pendingFetch) {
        return pendingFetch;
    }

    pendingFetch = (async () => {
        try {
            const response = await ProjectService.getProjectBaseOptions();
            const options = (response && response.data && response.data.projectManagerOptions)
                ? (response.data.projectManagerOptions as IProjectBaseOption[])
                : [];
            cachedProjectManagerOptions = options;
            return options;
        } catch (error) {
            cachedProjectManagerOptions = [];
            return [];
        } finally {
            pendingFetch = null;
        }
    })();

    return pendingFetch;
};

const ProjectManagerSelect: React.FC<ProjectManagerSelectProps> = ({
    className,
    value,
    onChange,
    placeholder = '请选择项目经理',
    allowClear = true,
    disabled = false,
}) => {
    const [options, setOptions] = useState<ProjectManagerOption[]>(cachedProjectManagerOptions || []);

    useEffect(() => {
        let mounted = true;
        fetchProjectManagerOptions().then((list) => {
            if (mounted) {
                setOptions(list || []);
            }
        });
        return () => {
            mounted = false;
        };
    }, []);

    return (
        <Select
            className={className}
            allowClear={allowClear}
            value={value === null ? undefined : value}
            onChange={(nextValue) => onChange && onChange(nextValue ?? null)}
            placeholder={placeholder}
            disabled={disabled}
        >
            {options.map(item => (
                <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>
            ))}
        </Select>
    );
};

export default ProjectManagerSelect;
